import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, tap } from 'rxjs';
import { Paginator } from 'src/app/shared/models/paginator';
import { TableHeader } from 'src/app/shared/models/table';
import { environment } from 'src/environments/environment';
import { TareaReporte } from '../../tasks/tarea-reporte';
import { PageableService } from './../../../shared/services/pageable.service';
import { Area } from './models/area';
import { ParametroLista, ParametroReporte } from './models/parametro';
import { Reporte } from './models/reporte';
import { ReporteData } from './models/reporte-data';
@Injectable({
  providedIn: 'root'
})
export class ReportsService {

  constructor(private http: HttpClient, private pageableService: PageableService) { }
  /**
   * Gets the reports by area
   * @param {string} areaId
   * @param {number} page
   * @returns {Observable<Reporte[]>}
   */
  getReportsByArea(areaId: string, page: number = 0): Observable<Paginator<Reporte>> {
    return this.http.get<Paginator<Reporte>>(`${environment.urlBase}/report/area/${areaId}?pagina=${page}`);
  }

  /** 
   * Gets the parameters by report
   * @param {string} reportId
   * @returns {Observable<ParametroReporte[]>}
   */
  getReportParameters(reportId: string): Observable<ParametroReporte[]> {
    return this.http.get<ParametroReporte[]>(`${environment.urlBase}/param-report/${reportId}`);
  }

  /** 
   * Creates the report task
   * @param {TareaReporte} reportTask
   * @returns {Observable<TareaReporte>}
   */
  generateReportTask(reportTask: TareaReporte): Observable<TareaReporte> {
    return this.http.post<TareaReporte>(`${environment.urlBase}/report-task/`, reportTask);
  }

  /** 
   * Gets the task report data
   * @param {string} taskId
   * @returns {Observable<ParametroReporte[]>}
   */
  getReportTaskData(taskId: string): Observable<ReporteData> {
    return this.http.get<ReporteData>(`${environment.urlBase}/report-task/result/${taskId}`);
  }

  /**
   * Updates the favorite property of the report
   * @param {string} reportId
   * @returns {Observable<boolean>}
   */
  setFavorite(reportId: string): Observable<boolean> {
    return this.http.put<boolean>(`${environment.urlBase}/favorite/report/${reportId}`, null);
  }

  /** 
   * Gets the list of query report procedures
   * @returns {Observable<string[]>}
   */
  getQueryReports(): Observable<string[]> {
    return this.http.get<string[]>(`${environment.urlBase}/report/bigquery/store-procedures`);
  }

  /** 
   * Creates a report
   * @param {Reporte} report
   * @returns {Observable<Reporte>}
   */
  createReport(report: Reporte): Observable<Reporte> {
    return this.http.post<Reporte>(`${environment.urlBase}/report/`, report);
  }

  /** 
   * Updates a report
   * @param {Reporte} report
   * @returns {Observable<Reporte>}
   */
  updateReport(report: Reporte): Observable<Reporte> {
    return this.http.put<Reporte>(`${environment.urlBase}/report/`, report);
  }

  /** 
   * Gets the list of queryParameters
   * @param {string} query
   * @returns {Observable<ParametroReporte[]>}
   */
  getQueryParameters(query: string): Observable<ParametroReporte[]> {
    return this.http.get<ParametroReporte[]>(`${environment.urlBase}/report/bigquery/parametros/${query}`);
  }

  /** 
   * Gets the list of Parameters
   * @returns {Observable<ParametroLista[]>}
   */
  getParametersList(): Observable<ParametroLista[]> {
    return this.http.get<ParametroLista[]>(`${environment.urlBase}/parametro-lista/all`);
  }

  /** 
   * Gets the report information by uuid
   * @param {string} reportId
   * @returns {Observable<Reporte>}
   */
  getReport(reportId: string): Observable<Reporte> {
    return this.http.get<Reporte>(`${environment.urlBase}/report/${reportId}`);
  }

  /**
   * Gets the repots by report group
   * @param {string} reportGroup
   * @param {number} page
   * @param {number} pageQuantity
   * @param {string} header
   * @param {string} filter
   * @param {string} order
   * @returns {Observable<Paginator<Reporte>>}
   */
  getReportsByReportGroup(reportGroup: string, page: number, pageQuantity: number, header?: string, filter?: string, order?: string): Observable<Paginator<Reporte>> {
    return this.pageableService.getData<Reporte>(`${environment.urlBase}/report/grupo-reporte/${reportGroup}`, page, pageQuantity, header, filter, order);
  }

  /**
   * Gets the repots by report group
   * @param {string} reportGroup
   * @param {BehaviorSubject<TableHeader | undefined>} search$
   * @param {number} page
   * @param {number} pageQuantity
   * @returns {Observable<Paginator<Reporte>>}
   */
  getReportsByFilters(reportGroup: string, search$: BehaviorSubject<TableHeader | undefined>, page: number, pageQuantity: number): Observable<Paginator<Reporte>> {
    return this.pageableService.searchData<Reporte>(search$, page, pageQuantity, `${environment.urlBase}/report/grupo-reporte/${reportGroup}`);
  }
  
}